import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { ScreenReaderOnly } from '../ScreenReaderOnly/ScreenReaderOnly.js';
import { Typography } from '../Typography/Typography.js';

var _excluded = ["label", "color", "size", "srOnlyText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LINE_CLAMP_ONE = 1;
var LINE_CLAMP_TWO = 2;
var NotificationBadge = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _label$toString$lengt;
  var label = _ref.label,
    color = _ref.color,
    size = _ref.size,
    srOnlyText = _ref.srOnlyText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var labelLength = (_label$toString$lengt = label === null || label === void 0 ? void 0 : label.toString().length) !== null && _label$toString$lengt !== void 0 ? _label$toString$lengt : 0;
  var minBadgeSize = size === 'm' ? '24px' : '16px';
  var labelVariant = label && _objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'solid',
    borderColor: 'base.inverted.strong',
    height: minBadgeSize,
    width: labelLength === 2 && size === 's' || labelLength > 2 ? 'fit-content' : minBadgeSize
  }, size === 'm' ? {
    py: '4',
    px: '8',
    borderWidth: '2'
  } : {
    py: '0',
    px: '4',
    borderWidth: '1'
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: !label ? '6px' : undefined,
    height: !label ? '6px' : undefined,
    backgroundColor: color,
    borderRadius: "max"
  }, labelVariant, rest, {
    ref: ref
  }), label && /*#__PURE__*/React.createElement(Typography, {
    "aria-hidden": srOnlyText ? true : undefined,
    variant: "caption-default",
    textColor: "base.inverted",
    interactive: "none",
    lineClamp: labelLength > LINE_CLAMP_TWO ? LINE_CLAMP_ONE : undefined
  }, label), srOnlyText && /*#__PURE__*/React.createElement(ScreenReaderOnly, null, srOnlyText));
});
NotificationBadge.defaultProps = {
  size: 'm',
  color: 'feedback.negative'
};
var NotificationBadgeMemoized = /*#__PURE__*/React.memo(NotificationBadge);
NotificationBadgeMemoized.displayName = 'NotificationBadge';

export { NotificationBadgeMemoized as NotificationBadge, NotificationBadge as NotificationBadgeWithoutMemoized };
//# sourceMappingURL=NotificationBadge.js.map
